export const COLLECTIONS_NAMES = {
  USERS: "users",
  EVENTS: "events",
  VENUES: "venues",
  MANAGERS: "managers",
  TICKETS: "tickets",
  CALLAPPCOL: "CalendarAppointmentCollection",
  NOTIFICATIONS: "notifications",
};
